import { makeStyles } from "tss-react/mui"
import { CardContentBox, CardListItem } from "./CardElements"
import { AdminSecuritySettings } from "../../users/userTypes"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { StandardChip } from "../../../shared/components/badges/StandardChip"

const useStyles = makeStyles()(() => ({
    chip: {
        height: "auto",
        fontWeight: 500,
    },
}))

type SecurityCardProps = { securitySettings?: AdminSecuritySettings }

export const SecurityCard = ({ securitySettings }: SecurityCardProps) => {
    const { classes } = useStyles()

    const isManage = securitySettings?.allowToCreateAdmins

    return (
        <CardContentBox
            title={
                <LocalizedStrict id="profile-security">
                    <>Security</>
                </LocalizedStrict>
            }
        >
            <CardListItem
                title={
                    <LocalizedStrict id="profile-security-manage-admins">
                        <>Manage admins:</>
                    </LocalizedStrict>
                }
                content={
                    <StandardChip variant={isManage ? "success" : "red"} size="small" className={classes.chip}>
                        {isManage ? (
                            <LocalizedStrict id="profile-security-manage-admins-yes">
                                <>Yes</>
                            </LocalizedStrict>
                        ) : (
                            <LocalizedStrict id="profile-security-manage-admins-no">
                                <>No</>
                            </LocalizedStrict>
                        )}
                    </StandardChip>
                }
                isOneLineContent
            />

            <CardListItem
                title={
                    <LocalizedStrict id="profile-security-ip-address-allowlist">
                        <>IP address allowlist:</>
                    </LocalizedStrict>
                }
                content={
                    !!securitySettings?.restrictAccessToIpAddresses
                        ? securitySettings?.restrictAccessToIpAddresses
                        : "-"
                }
                isOneLineContent
            />
        </CardContentBox>
    )
}
